// Module
var code = "<massia-form form=\"true\" label=\"{{$ctrl.caracteristique.libelle}}\" label-class=\"{{$ctrl.isObligatoire ? 'mandatory-field' : ''}}\"> <textarea class=\"form-control\" ng-model=\"$ctrl.model.value\" ng-disabled=\"$ctrl.lecture\"></textarea> </massia-form> ";
// Exports
module.exports = code;